import { ScheduledAppointment } from '@enaratech/funnel-helper';
import { Dispatch } from 'react';

export enum SSBFlowState {
  InitSchedulingProcess = 'init-scheduling-process',
  WaitingForUserSelection = 'waiting-for-user-selection',
  FetchAppointmentsAvailability = 'fetching-appointments-availability',
  CreateAppointment = 'create-appointment',
  AllScheduled = 'all-scheduled',
  GoToNextStep = 'go-to-next-step',
  SkipStep = 'skip-step',
}

export type RecentBookingEntry = {
  appointment: ScheduledAppointment;
  recordedAt: number;
};

export type RecentlyBookedAppointments = Partial<
  Record<string, RecentBookingEntry>
>;

export type SSBState = {
  flowState: SSBFlowState | null;
  recentlyBookedAppointments: RecentlyBookedAppointments;
};

export type SSBContextValue = {
  ssbState: SSBFlowState | null;
  recentlyBookedAppointments: RecentlyBookedAppointments;
  dispatchSSB: Dispatch<SSBActionTypes>;
};

export const SET_SSB_INFO = '@enara/types/set-ssb-info';
export const RECORD_RECENT_BOOKING = '@enara/types/record-recent-booking';
export const CLEAR_RECENT_BOOKING = '@enara/types/clear-recent-booking';
export const CLEAR_ALL_RECENT_BOOKINGS = '@enara/types/clear-all-recent-bookings';

export type SetSSBInfoType = {
  type: typeof SET_SSB_INFO;
  payload: SSBFlowState | null;
};

export type RecordRecentBookingType = {
  type: typeof RECORD_RECENT_BOOKING;
  payload: {
    code: string;
    appointment: ScheduledAppointment;
  };
};

export type ClearRecentBookingType = {
  type: typeof CLEAR_RECENT_BOOKING;
  payload: { code: string };
};

export type ClearAllRecentBookingsType = {
  type: typeof CLEAR_ALL_RECENT_BOOKINGS;
};

export type SSBActionTypes =
  | SetSSBInfoType
  | RecordRecentBookingType
  | ClearRecentBookingType
  | ClearAllRecentBookingsType;
